/*
 * DRIVLY-UI React Components
 * @license MIT
 */
function t(){let t;return{before({doc:e}){var d;let n=e.documentElement;t=(null!=(d=e.defaultView)?d:window).innerWidth-n.clientWidth},after({doc:e,d:d}){let n=e.documentElement,i=n.clientWidth-n.offsetWidth,l=t-i;d.style(n,"paddingRight",`${l}px`)}}}export{t as adjustScrollbarPadding};
//# sourceMappingURL=adjust-scrollbar-padding.js.map
